const isObject = obj => obj && typeof obj === 'object';
export const getFirstErrorPath = (object) => {
    if (!isObject(object)) {
        return '';
    }
    const currentKey = Object.keys(object)[0];
    if (!getFirstErrorPath(object[currentKey])) {
        return currentKey;
    }
    return currentKey + '.' + getFirstErrorPath(object[currentKey]);
};
